module.exports = __webpack_public_path__ + "img/14.10bae45f.webp";